/**
 * Паттерн для классов-одиночек
 *
 * При повторном создании, в рамках одной боласти видимости, повторно не создается
 */

export class Singleton {
    private static instance: Singleton | null = null;

    public constructor() {
        if (Singleton.instance) {
            return Singleton.instance;
        }

        this.run();

        Singleton.instance = this;
    }

    public run(): void {}
}
